const getAllBranchesOfCompanyAPI = () => 'api/platform/companies/get-rdn-branches-list';
const getAllUsersInCompanyAPI = (page) => `api/platform/companies/get-rdn-users-list?page=${page}`;
const getRDNAgentAPI = (rdnId) => `api/platform/companies/get-rdn-agent?rdnId=${rdnId}`;
const loginCompanyAPI = () => 'api/platform/auth/login';
const logoutCompanyAPI = () => 'api/platform/auth/logout';
const getAllBranchesInCompanyAPI = () => 'api/platform/companies/get-branches';
const getAllRolesInCompanyAPI = () => 'api/platform/companies/get-roles';
const createUserAPI = () => 'api/platform/companies/add-users';
const deleteUserAPI = () => 'api/platform/companies/delete-users';
const postCompanyDetailsAPI = () => 'api/platform/companies/add-company-details';
const editCompanyDetailsAPI = () => 'api/platform/companies/edit-company-details';
const getExistingBasicInfoAPI = () => 'api/platform/companies/get-company-details';
const updateCompanySettingsAPI = () => 'api/settings/update-company-settings';
const getCompanyAPI = () => 'api/platform/companies/get-company';
const addCompanyBranchesAPI = () => 'api/platform/companies/add-branches';
const registerCompanyDoneAPI = () => 'api/platform/companies/complete-company-registration';
const companyReAppealAPI = () => 'api/platform/company-re-appeal';
const getAllPricesAPI = () => 'api/platform/subscription/all-prices';
const getAllSubscriptionsPaymentLinkTrialAPI = (query) => `api/platform/subscription/billing-link-trial?${query}`;
const changePaymentMethodAPI = () => 'api/platform/subscription/change_payment';
const getAllUsersInABranchAPI = () => 'api/users';
// const updateUserAPI = (userId, branchId) =>
//   `api/branches/update-user-branch?userId=${userId}&branchId=${branchId}`;
const getAllShiftInBranchAPI = () => 'api/shifts';
const deleteBranchAPI = (branchId) => `api/branches/${branchId}`;
const getPaymentHistoryAPI = () => 'api/platform/subscription/payment-history';
/**
 * @deprecated This endpoint is no longer used
 */
const deleteSubBranchesAPI = () => 'api/platform/companies/delete-sub-branches';

export const newCompanyEndpoints = {
  getAllSubscriptionsPaymentLinkTrialAPI,
  getAllBranchesInCompanyAPI,
  getAllBranchesOfCompanyAPI,
  getAllRolesInCompanyAPI,
  getExistingBasicInfoAPI,
  getCompanyAPI,
  getAllUsersInABranchAPI,
  getAllUsersInCompanyAPI,
  getAllPricesAPI,
  editCompanyDetailsAPI,
  registerCompanyDoneAPI,
  changePaymentMethodAPI,
  addCompanyBranchesAPI,
  getAllShiftInBranchAPI,
  postCompanyDetailsAPI,
  getPaymentHistoryAPI,
  deleteSubBranchesAPI,
  companyReAppealAPI,
  logoutCompanyAPI,
  deleteBranchAPI,
  loginCompanyAPI,
  // updateUserAPI,
  createUserAPI,
  deleteUserAPI,
  getRDNAgentAPI,
  updateCompanySettingsAPI,
};
